/* DEFAULT_CONFIG =============================================================================== */
export const DEFAULT_CONFIG = {
  topbar: {
    active: false,
  },
  navbar: {
    active: true,
  },
  header: {
    active: true,
  },
  menubar: {
    active: true,
  },
  toolbar: {
    active: true,
  },
  sidebar: {
    active: false,
  },
}
